import { combineReducers } from 'redux';
import home from './home.reducer';
import purchaseLicense from './purchaseLicense.reducer';
import general from './general.reducer';
import auth from './auth.reducer';
import packets from './packets.reducer';
import service from './service.reducer';
import serviceFeature from './serviceFeature.reducer';
import featureType from './featueType.reducer';
import summaryOrder from './summaryOrder.reducer';
import google from './google.reducer';
import security from './security.reducer';
import license from './license.reducer';
import emails from './email.reducer';

export default combineReducers(
  {
    auth,
    home,
    purchaseLicense,
    general,
    packets,
    service,
    serviceFeature,
    featureType,
    summaryOrder,
    google,
    security,
    license,
    emails,
  },
);
